module.exports = __webpack_public_path__ + "img/tel_img.9cd2da8c.png";